import "core-js/modules/es.array.push.js";
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue";
import _imports_0 from '../../images/copy1.png';
const _hoisted_1 = {
  class: "index mine"
};
const _hoisted_2 = {
  class: "head"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "info"
};
const _hoisted_5 = {
  class: "info-name ellipsis2"
};
const _hoisted_6 = {
  key: 0,
  class: "info-code"
};
const _hoisted_7 = {
  class: "box"
};
const _hoisted_8 = ["src"];
import { useStore } from "@/store/index";
import { storeToRefs } from 'pinia';
import { onMounted } from 'vue';
import CustomBar from "@/components/customBar";
import icon6 from "../../images/icon6.png";
import icon7 from "../../images/icon7.png";
import icon13 from "../../images/icon13.png";
import icon9 from "../../images/icon9.png";
import icon14 from "../../images/icon14.png";
import Clipboard from "clipboard";
import { usebaseRouter } from "@/utils/hooks";

import { showConfirmDialog, showToast } from 'vant/es';
import 'vant/es/dialog/style/index';
import 'vant/es/toast/style/index';
export default {
  __name: 'index',
  setup(__props) {
    const {
      navigate
    } = usebaseRouter();
    const cellList = [{
      name: '我的积分',
      icon: icon6,
      path: 'myIntegral'
    }, {
      name: '我的订单',
      icon: icon7,
      path: 'order'
    }, {
      name: '收货地址',
      icon: icon13,
      path: 'siteList'
    }, {
      name: '我的用户',
      icon: icon9,
      path: 'myUsers'
    }, {
      name: '退出登录',
      icon: icon14,
      path: ''
    }];
    const store = useStore();
    const {
      userInfo
    } = storeToRefs(store);
    const toPage = path => {
      if (path) {
        navigate(path);
      } else {
        showConfirmDialog({
          title: '提示',
          message: '是否确认退出登录？'
        }).then(() => {
          showToast('退出登录成功');
          localStorage.clear();
          sessionStorage.clear();
          store.clearStore();
          location.replace(location.origin + '/#/home');
        });
      }
    };
    const copyToClipboard = type => {
      let text = '';
      if (type == 'code') {
        text = userInfo.value.inviteCode;
      } else {
        text = location.origin + '/#/register?inviteCode=' + userInfo.value.inviteCode;
      }
      const clipboard = new Clipboard('.btn', {
        text: () => text
      });
      clipboard.on('success', function (e) {
        showToast('复制成功');
        clipboard.destroy();
      });
      clipboard.on('error', function (e) {
        showToast('复制失败');
        clipboard.destroy();
      });
      clipboard.onClick(event);
    };
    onMounted(() => {
      store.updataUserInfo();
    });
    return (_ctx, _cache) => {
      const _component_van_icon = _resolveComponent("van-icon");
      const _component_van_cell = _resolveComponent("van-cell");
      const _component_van_cell_group = _resolveComponent("van-cell-group");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_unref(CustomBar), {
        title: "个人中心",
        isBg: true
      }), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
        class: "userinfo",
        onClick: _cache[1] || (_cache[1] = $event => _ctx.$router.push('userInfo'))
      }, [_createElementVNode("img", {
        class: "avatar",
        src: _unref(userInfo).avatar,
        alt: ""
      }, null, 8, _hoisted_3), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(_unref(userInfo).nickname), 1), _unref(userInfo).inviteCode ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createTextVNode(" 我的邀请码:" + _toDisplayString(_unref(userInfo).inviteCode) + " ", 1), _createElementVNode("div", {
        class: "copy",
        onClick: _cache[0] || (_cache[0] = _withModifiers($event => copyToClipboard('code'), ["stop"]))
      })])) : _createCommentVNode("", true)]), _createVNode(_component_van_icon, {
        name: "arrow",
        size: "20",
        color: "#999999"
      })])]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_van_cell_group, null, {
        default: _withCtx(() => [_unref(userInfo).inviteCode ? (_openBlock(), _createBlock(_component_van_cell, {
          key: 0,
          onClick: _cache[2] || (_cache[2] = $event => copyToClipboard('url'))
        }, {
          title: _withCtx(() => _cache[3] || (_cache[3] = [_createElementVNode("span", {
            class: "custom-title"
          }, "复制邀请链接", -1)])),
          "right-icon": _withCtx(() => _cache[4] || (_cache[4] = [_createElementVNode("img", {
            class: "cell-icon copyurl",
            src: _imports_0
          }, null, -1)])),
          _: 1
        })) : _createCommentVNode("", true), (_openBlock(), _createElementBlock(_Fragment, null, _renderList(cellList, (item, index) => {
          return _createVNode(_component_van_cell, {
            title: item.name,
            "is-link": true,
            key: index,
            onClick: $event => toPage(item.path)
          }, {
            icon: _withCtx(() => [_createElementVNode("img", {
              class: "cell-icon",
              src: item.icon
            }, null, 8, _hoisted_8)]),
            _: 2
          }, 1032, ["title", "onClick"]);
        }), 64))]),
        _: 1
      })])])], 64);
    };
  }
};